import { Loader2, RefreshCw } from "lucide-react";

/**
 * Per-line refresh button, shown next to the info/expand (ⓘ) button in the
 * PON / VDSL inventory grids. Submits a single-line refresh job (refresh_onu
 * / refresh_port) that re-collects state + optical/line-speed + MAC + device
 * id + occupancy for just that line; the grid row updates itself when the
 * job's terminal events invalidate the inventory query.
 *
 * Matches InfoExpandButton's footprint (h-6 w-6 button, h-3.5 icon). Shows a
 * spinner + disables while the submit/job is in flight.
 */
export function RefreshLineButton({
  busy,
  onClick,
  label,
}: {
  busy: boolean;
  onClick: () => void;
  label?: string;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={busy}
      aria-label={label ?? "Refresh this line"}
      title={label ?? "Re-collect all stats for this line"}
      className={[
        "inline-flex h-6 w-6 items-center justify-center rounded",
        "text-slate-500 hover:bg-slate-800 hover:text-slate-200",
        "transition-[scale,background-color,color] duration-150 ease-out",
        "active:enabled:scale-[0.96]",
        "focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-emerald-500",
        "disabled:cursor-not-allowed disabled:opacity-50",
      ].join(" ")}
    >
      {busy ? (
        <Loader2 className="h-3.5 w-3.5 animate-spin text-emerald-400" />
      ) : (
        <RefreshCw className="h-3.5 w-3.5" />
      )}
    </button>
  );
}
